import React, { createContext, useContext } from 'react';
export function useConfig() {
    return useContext(ConfigContext);
}
export function ConfigProvider({ config = {}, children }) {
    return (React.createElement(ConfigContext.Provider, { value: Object.assign(Object.assign({}, DEFAULT_CONFIG), config) }, children));
}
export const CONFIG_ID_ATTRIBUTE = 'BXP_CONFIG';
const DEFAULT_CONFIG = {
    environment: 'development',
    version: 'n/a',
    trelloClientBaseUrl: ''
};
const ConfigContext = createContext(DEFAULT_CONFIG);
//# sourceMappingURL=use-config.js.map